import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  HostListener,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Feature, TenantFeatures } from 'app/state/feature.repository';
import { Tenant } from 'app/state/tenants.repository';
// import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { DocumentTypesService } from '../../../../state/documenttype.service';
import { AuthRepository } from 'app/state/auth.repository';
import { DatalistOption } from 'app/state/abstract/base.repository';
import {
  MediaLibraryFileSelectorOptions,
  MediaLibraryService,
} from 'app/api/services/mediaLibrary.service';
import { MediaLibraryFileDto } from 'app/api/models/mediaLibrary/mediaLibraryFileDto';
import { ToastService, MessageText } from 'app/helpers/services/toastService';
import { environment } from 'environments/environment';
import { filter } from 'rxjs';

const FONT_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Lucida Handwriting', label: 'Lucida Handwriting' },
  { value: 'Comic Sans MS', label: 'Comic Sans MS' },
  { value: 'Courier New', label: 'Courier New' },
  { value: '"Franklin Gothic", sans-serif', label: 'Franklin Gothic' },
  { value: '"Nybolig", sans-serif', label: 'Nybolig' },
];

const FEATURE_NAMES: { [f: string]: string } = {
  [TenantFeatures.News]: $localize`:News label:News`,
  [TenantFeatures.Calendar]: $localize`:Calendar label:Calendar`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.TimeLogs]: $localize`:TimeLogs label:TimeLogs`,
  [TenantFeatures.Sprints]: $localize`:Sprints label:Sprints`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.Whistleblow]: $localize`:Whistleblow label:Whistleblow`,
  // [TenantFeatures.Messages]: $localize`:Messages label:Messages`,
  //[TenantFeatures.Apv]: $localize`:Apv label:Apv`,
  [TenantFeatures.Documents]: $localize`:Documents label:Documents`,
  //[TenantFeatures.Maps]: $localize`:Maps label:Maps`,
  [TenantFeatures.Notifications]: $localize`:Notifications label:Notifications`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.Marketplace]: $localize`:Marketplace label:Marketplace`,
  [TenantFeatures.Email]: $localize`:Email label:Email`,
  [TenantFeatures.ToolBox]: $localize`:ToolBox label:ToolBox`,
  [TenantFeatures.PersonalPlan]: $localize`:PersonalPlan label:PersonalPlan`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.OutOfOfficeStatus]: $localize`:OutOfOfficeStatus label:OutOfOfficeStatus`,
  [TenantFeatures.Onboarding]: $localize`:Onboarding label:Onboarding`,
  [TenantFeatures.Feed]: $localize`:Feed label:Feed`,
  [TenantFeatures.AIRoleplay]: $localize`:Roleplay label:Roleplay`,
  // [TenantFeatures.Chat]: $localize`:Chat label:Chat`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.Absent]: $localize`:Absent label:Absent`,
  [TenantFeatures.PlayBook]: $localize`:PlayBook label:PlayBook`,
  [TenantFeatures.PlayBookPilot]: $localize`:PlayBookPilot label:PlayBookPilot`,
  [TenantFeatures.Poll]: $localize`:Poll label:Poll`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.PageBuilder]: $localize`:PageBuilder label:PageBuilder`,
  [TenantFeatures.Todo]: $localize`:Todo label:Todo`,
  // Disabled feature — removed from selectable features and menus
  // [TenantFeatures.Phonebook]: $localize`:Phonebook label:Phonebook`,
  [TenantFeatures.CRM]: $localize`:CRM label:CRM`,
  [TenantFeatures.Employee]: $localize`:Employee label:Employee`,
  [TenantFeatures.DataRoom]: $localize`:DataRoom label:DataRoom`,
  // Disabled features — removed from selectable features and menus
  // [TenantFeatures.AISelling]: $localize`:AISelling label:AISelling`,
  // [TenantFeatures.Chat]: $localize`:Chat label:Chat`,
  // [TenantFeatures.Currency]: $localize`:Currency label:Currency`,
  // [TenantFeatures.Canvas]: $localize`:Canvas label:Canvas`,
  [TenantFeatures.Product]: $localize`:SDS Links/CAS label:SDS Links/CAS`,
  [TenantFeatures.KemiHotelletAPV]: $localize`:KemiHotelletAPV label:KemiHotelletAPV`,
  [TenantFeatures.AIAssistant]: $localize`:AIAssistant label:AI Assistant`,
  [TenantFeatures.Gamification]: $localize`:Gamification label:Gamification`,
  [TenantFeatures.Billing]: $localize`:Billing label:Billing`,
};

@Component({
  selector: 'app-tenant-form',
  templateUrl: './tenant-form.component.html',
  styleUrls: ['./tenant-form.component.scss'],
  standalone: false,
})
export class TenantFormComponent implements OnInit {
  form?: UntypedFormGroup;
  fontOptions = FONT_OPTIONS;
  file: File | null = null;

  myOptions: any;
  isPartner: boolean = false;
  featureOptions: DatalistOption[] | null = null;
  mobileFeatureOptions: DatalistOption[] | null = null;
  calendarHere$ = false;
  chatGPTForTenant: boolean = false;
  chatGPTForCoach: boolean = false;
  publicDataRoom: boolean = false;
  speechToText: boolean = false;
  liveAvatar: boolean = false;
  logoMediaLibraryFile?: MediaLibraryFileDto;
  mobileLogoMediaLibraryFile?: MediaLibraryFileDto;
  backgroundColor?: string;

  userOptions: DatalistOption[] | null = null;
  selectedUserIds: string[] = [];

  @Input() editedTenant?: Tenant;

  @Input() set usersOptions(value: DatalistOption[] | null) {
    this.userOptions = value;

    this.selectedUserIds = (value ?? [])
      .filter((option) => option.selected)
      .map((option) => option.value);

    this.form?.patchValue({
      userIds: this.selectedUserIds,
    });
  }

  @Input() set features(value: Feature[] | null) {
    if (!value) {
      this.featureOptions = null;
    } else {
      console.log(value);
      this.featureOptions = value

        .map((x) => ({
          value: x.id,
          label: FEATURE_NAMES[x.name],
        }))
        .filter((x) => x.label);
    }
  }

  @Output() tenantSubmit = new EventEmitter<Partial<Tenant>>();

  constructor(
    private toastService: ToastService,
    public authRepo: AuthRepository,
    private formBuilder: UntypedFormBuilder,
    public documenttypesService: DocumentTypesService,
    public mediaLibraryService: MediaLibraryService,
  ) {}

  ngOnInit() {
    this.isPartner = this.editedTenant?.isPartnerTenant ?? false;

    if (this.editedTenant) {
      this.calendarHere$ = this.editedTenant.features.some(
        (x) => x.name == 'Calendar',
      );
      this.mobileFeatureOptions =
        this.featureOptions?.filter((x) =>
          this.editedTenant?.features?.map((x) => x.id).includes(x.value),
        ) ?? null;
      this.logoMediaLibraryFile = this.editedTenant.logoMediaFile;
      this.mobileLogoMediaLibraryFile = this.editedTenant.mobileLogoMediaFile;
    }

    this.form = this.formBuilder.group({
      name: [this.editedTenant?.name, Validators.required],
      userIds: [
        this.selectedUserIds,
        [Validators.required, Validators.minLength(1)],
      ],
      cvr: [this.editedTenant?.cvr],
      address: [this.editedTenant?.address],
      mainMail: [this.editedTenant?.mainMail],
      remarks: [this.editedTenant?.remarks],
      phoneNumber: [this.editedTenant?.phoneNumber],
      mapZoom: [this.editedTenant?.mapZoom],
      startingAddress: [this.editedTenant?.startingAddress],
      startingLat: [this.editedTenant?.startingLat],
      startingLng: [this.editedTenant?.startingLng],
      featureIds: [this.editedTenant?.features?.map((x) => x.id)],
      mobileFeatureIds: [this.editedTenant?.mobileFeatureIds],
      showCalendarAsList: [this.editedTenant?.showCalendarAsList],
      chatGPTForTenant: [
        this.editedTenant?.customTenantProperties?.chatGPTForTenant,
      ],

      chatGPTForCoach: [
        this.editedTenant?.customTenantProperties?.chatGPTForCoach,
      ],
      publicDataRoom: [
        this.editedTenant?.customTenantProperties?.publicDataRoom,
      ],
      multipleDataRoom: [
        this.editedTenant?.customTenantProperties?.multipleDataRoom,
      ],
      hideMediaLibraryFolder: [
        this.editedTenant?.customTenantProperties?.hideMediaLibraryFolder,
      ],
      hideUsersFolder: [
        this.editedTenant?.customTenantProperties?.hideUsersFolder,
      ],
      hideTemplateFolder: [
        this.editedTenant?.customTenantProperties?.hideTemplateFolder,
      ],
      speechToText: [this.editedTenant?.customTenantProperties?.speechToText],
      liveAvatar: [this.editedTenant?.customTenantProperties?.liveAvatar],
      useKmAsValues: [
        this.editedTenant?.useKmAsValues != null
          ? this.editedTenant?.useKmAsValues
          : true,
      ],
      allowUnauthorizedAccess: [
        this.editedTenant?.allowUnauthorizedAccess != null
          ? this.editedTenant?.allowUnauthorizedAccess
          : false,
      ],
      tenantDocumentId: [this.editedTenant?.tenantDocumentId],
      preferedUrl: [this.editedTenant?.preferedUrl],
      isPartnerTenant: [this.editedTenant?.isPartnerTenant ?? false],
      isDisabled: [this.editedTenant?.isDisabled ?? false],
      maxUsersCanCreate: [
        this.editedTenant?.maxUsersCanCreate,
        [Validators.min(0), Validators.pattern('^[0-9]*$')],
      ],
      maxTenantsCanCreate: [
        this.editedTenant?.maxTenantsCanCreate,
        [Validators.min(0), Validators.pattern('^[0-9]*$')],
      ],

      primaryColor: [
        this.editedTenant?.customTenantProperties?.primaryColor,
        [Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)],
      ],
      secondaryColor: [
        this.editedTenant?.customTenantProperties?.secondaryColor,
        [Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)],
      ],
      backgroundColor: [
        this.editedTenant?.customTenantProperties?.backgroundColor,
        [Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)],
      ],
      menuBackgroundColor: [
        this.editedTenant?.customTenantProperties?.menuBackgroundColor,
        [Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)],
      ],
      appThemeColor: [
        this.editedTenant?.customTenantProperties?.appThemeColor,
        [Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)],
      ],
      emailColor: [
        this.editedTenant?.customTenantProperties?.emailColor,
        [Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)],
      ],
      fontFamily: [this.editedTenant?.customTenantProperties?.fontFamily],
    });
  }

  updateValue(control: string, value: any) {
    if (control === 'fontFamily' && value === 'default') {
      value = null;
    }

    const controlObject = this.form?.get(control);
    controlObject?.setValue(value);
    controlObject?.markAsTouched();
    if (control === 'featureIds') {
      this.calendarHere$ = controlObject?.value.includes(
        this.featureOptions?.find((x) => x.label == 'Calendar')?.value,
      );
      this.mobileFeatureOptions =
        this.featureOptions?.filter((x) =>
          this.form?.value.featureIds.includes(x.value),
        ) ?? null;
    }
  }

  changeIsPartner(event: any) {
    this.isPartner = event.target.checked;
    if (!this.isPartner) {
      this.form?.controls['maxUsersCanCreate'].setValue(null);
      this.form?.controls['maxTenantsCanCreate'].setValue(null);
    }
  }

  public handleAddressChange(address: any) {
    this.form?.controls['startingAddress'].setValue(address.formatted_address);
    this.form?.controls['startingLat'].setValue(
      address.geometry.location.lat(),
    );
    this.form?.controls['startingLng'].setValue(
      address.geometry.location.lng(),
    );
    return address.formatted_address;
  }

  onDesktopLogoMediaLibraryFileSelected(files: MediaLibraryFileDto[]) {
    this.logoMediaLibraryFile = files[0];
  }
  onMobileLogoMediaLibraryFileSelected(files: MediaLibraryFileDto[]) {
    this.mobileLogoMediaLibraryFile = files[0];
  }

  onLogoMediaLibraryFileRemoved(desktop: boolean) {
    desktop
      ? (this.logoMediaLibraryFile = undefined)
      : (this.mobileLogoMediaLibraryFile = undefined);
  }

  onSubmit() {
    if (this.form && !this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const userIds = this.form?.value?.userIds ?? [];
    if (!userIds.length) {
      this.form?.get('userIds')?.setErrors({ noUsers: true });
      this.form?.markAllAsTouched();
      return;
    }
    const preferedUrl = this.form?.value?.preferedUrl?.trim();
    if (preferedUrl && !/^https?:\/\//i.test(preferedUrl)) {
      this.toastService.showWarning(MessageText.putHttps);
      return;
    }
    var curTenantId = localStorage.getItem('activeTenantId');
    var tenantId = curTenantId ? curTenantId : null;
    this.tenantSubmit.emit({
      name: this.form?.value?.name.toString().trim(),
      cvr: this.form?.value?.cvr,
      address: this.form?.value?.address,
      mainMail: this.form?.value?.mainMail,
      remarks: this.form?.value?.remarks,
      phoneNumber: this.form?.value?.phoneNumber,
      mapZoom: this.form?.value?.mapZoom,
      startingAddress: this.form?.value?.startingAddress,
      startingLat: this.form?.value?.startingLat,
      startingLng: this.form?.value?.startingLng,
      featureIds: this.form?.value?.featureIds,
      mobileFeatureIds: this.form?.value?.mobileFeatureIds ?? [],
      showCalendarAsList: !!this.form?.value.showCalendarAsList,
      useKmAsValues: this.form?.value?.useKmAsValues,
      allowUnauthorizedAccess: this.form?.value?.allowUnauthorizedAccess,
      tenantDocumentId: this.editedTenant?.tenantDocumentId,
      pageHtml: this.editedTenant?.pageHtml,
      isPartnerTenant: this.form?.value.isPartnerTenant,
      isDisabled: this.form?.value.isDisabled,
      maxUsersCanCreate: this.form?.value.maxUsersCanCreate,
      maxTenantsCanCreate: this.form?.value.maxTenantsCanCreate,
      tenantId: tenantId!,
      logoMediaFile: this.logoMediaLibraryFile,
      mobileLogoMediaFile: this.mobileLogoMediaLibraryFile,
      userIds: this.form?.value?.userIds ?? [],
      preferedUrl: this.form?.value?.preferedUrl,
      customTenantProperties: {
        ...this.editedTenant?.customTenantProperties,
        primaryColor: this.form?.value.primaryColor || null,
        secondaryColor: this.form?.value.secondaryColor || null,
        backgroundColor: this.form?.value.backgroundColor || null,
        menuBackgroundColor: this.form?.value.menuBackgroundColor || null,
        appThemeColor: this.form?.value.appThemeColor || null,
        emailColor: this.form?.value.emailColor || null,
        fontFamily: this.form?.value.fontFamily || null,
        chatGPTForTenant: this.form?.value.chatGPTForTenant || false,

        chatGPTForCoach: this.form?.value.chatGPTForCoach || false,
        publicDataRoom: this.form?.value.publicDataRoom || false,
        multipleDataRoom: this.form?.value.multipleDataRoom || false,
        hideMediaLibraryFolder:
          this.form?.value.hideMediaLibraryFolder || false,
        hideUsersFolder: this.form?.value.hideUsersFolder || false,
        hideTemplateFolder: this.form?.value.hideTemplateFolder || false,
        speechToText: this.form?.value.speechToText || false,
        liveAvatar: this.form?.value.liveAvatar || false,
      },
    });
  }

  addMediaLibraryFile(type: string) {
    let options = new MediaLibraryFileSelectorOptions();
    options.allowImagesSelection = true;
    options.showOnlyPrivateFiles = true;

    this.mediaLibraryService
      .selectFileFromMediaLibraryInModalOptions(options)
      .subscribe((data) => {
        if (data) {
          if (type === 'logo') {
            this.logoMediaLibraryFile = data[0];
          } else if (type === 'mobile') {
            this.mobileLogoMediaLibraryFile = data[0];
          }
        }
      });
  }

  removeImage(type: string): void {
    if (type === 'logo') {
      this.logoMediaLibraryFile = undefined;
    } else if (type === 'mobile') {
      this.mobileLogoMediaLibraryFile = undefined;
    }
  }
}
